import React, { useEffect, useRef, useState } from 'react';
import skinImg from '../../assets/skin.png';

const MinecraftDoll = () => {
  const canvasRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    let skinViewer;
    let timer;
    let objectUrl = null;

    const scriptId = 'skinview3d-script';
    let script = document.getElementById(scriptId);

    const initViewer = async () => {
      if (!canvasRef.current) return;
      if (!window.skinview3d) {
        setErrorMsg("skinview3d library not loaded");
        setLoading(false);
        return;
      }

      try {
        const skinview3d = window.skinview3d;

        // Fetch the skin image and convert to a local object URL to bypass CORS and relative path resolving issues
        let skinSource = skinImg;
        try {
          const response = await fetch(skinImg);
          const blob = await response.blob();
          objectUrl = URL.createObjectURL(blob);
          skinSource = objectUrl;
        } catch (fetchErr) {
          console.warn("Failed to fetch skin as blob, falling back to direct URL", fetchErr);
        }

        skinViewer = new skinview3d.SkinViewer({
          canvas: canvasRef.current,
          width: 300,
          height: 380,
          skin: skinSource
        });

        // Set camera angle and options
        skinViewer.camera.position.set(-15, 12, 24);
        skinViewer.zoom = 0.95;

        // Auto rotation
        skinViewer.autoRotate = false;
        skinViewer.autoRotateSpeed = 0.5;

        // Enable user dragging/rotation controls
        skinViewer.controls.enableZoom = false;
        skinViewer.controls.enablePan = false;

        // Make background transparent
        skinViewer.background = null;

        // Load skin check
        skinViewer.loadSkin(skinSource).then(() => {
          setLoading(false);
        }).catch((err) => {
          console.error("Failed to load skin image:", err);
          setErrorMsg("Failed to load skin texture: " + err.message);
          setLoading(false);
        });

      
      } catch (err) {
        console.error("Error initializing skinview3d:", err);
        setErrorMsg("WebGL initialization failed: " + err.message);
        setLoading(false);
      }
    };

    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://cdn.jsdelivr.net/npm/skinview3d@3.4.2/bundles/skinview3d.bundle.js';
      script.async = true;
      script.onload = () => {
        initViewer();
      };
      script.onerror = () => {
        setErrorMsg("Failed to load skinview3d script");
        setLoading(false);
      };
      document.body.appendChild(script);
    } else {
      if (window.skinview3d) {
        initViewer();
      } else {
        script.addEventListener('load', initViewer);
      }
    }

    return () => {
      if (skinViewer) skinViewer.dispose();
      if (timer) clearTimeout(timer);
      if (script) {
        script.removeEventListener('load', initViewer);
      }
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, []);

  return (
    <div className="relative flex items-center justify-center w-[300px] h-[380px]">
      {loading && (
        <div className="absolute inset-0 flex items-center justify-center text-[#ffff55] font-mono text-sm uppercase tracking-widest animate-pulse">
          Loading 3D Player...
        </div>
      )}
      {errorMsg && (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-[#ff5555] font-mono text-xs uppercase tracking-wider p-4 text-center bg-black/60 z-20">
          <p className="font-bold mb-2">Error</p>
          <p>{errorMsg}</p>
        </div>
      )}
      <canvas 
        ref={canvasRef} 
        width="300"
        height="380"
        className="w-[300px] h-[380px] cursor-grab active:cursor-grabbing select-none outline-none"
      />
    </div>
  );
};

export default MinecraftDoll;

